<template>
  <div>
    <div class="box" v-if="isok">
      <div class="box-row">
        <div style=" margin-right: 20px;">
          <el-button @click="beforefeprint">簡易收據</el-button>
        </div>
        <div>適用於 80 寬度熱敏打印機</div>
      </div>
      <div class="box-row" v-if="printall">
        <div style=" margin-right: 20px;">
          <el-button @click="openprint">詳細收據</el-button>
        </div>
        <div>適用於 A4 打印機</div>
      </div>
    </div>
    <div v-if="!isok" style="text-align:center;">
      訂單不完整，無法打印
    </div>
    <el-dialog title="請選擇熱敏小票機" :visible.sync="feprintDialogVisible" :append-to-body="true" width="80%" :close-on-click-modal="false">
      <div>
        <el-select v-model="feprint_id" placeholder="請選擇">
          <el-option v-for="item in feprintlist" :key="item.id" :label="(item.scene==0?'【門店】':'【辦公室】')+item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="feprintDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="feprint()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['order_id','store_id'],
  data () {
    return {
      isok: false,
      showpicurl: '',
      showpicbox: false,
      data: [],
      encode_id: 0,
      printall: false,
      feprintDialogVisible: false,
      feprintlist: [],
      feprint_id: '',
    };
  },
  methods: {
    checkorder(){
      this.post('/api/order/checkorder',{
        order_id:this.order_id
      }).then(response=>{
        if(response.status=='success'){
          this.isok = true;
        }else{
          this.isok = false;
        }
      }).catch(error=>{
        console.log(error);
      })
    },
    async getfeprint () {
      this.feprint_id = '';
      let store_id = this.store_id;
      await this.post('/api/frprint/getfeprint', {
        store_id
      }).then(response => {
        response = response.filter(item => {
          return item.status == 0 ? true : false;
        })
        this.feprintlist = response;
      }).catch(error => {
        console.log(error);
      });
    },
    async beforefeprint () {
      await this.getfeprint();

      if (this.feprintlist.length == 0) {
        this.$notify({
          showClose: true,
          message: '請先添加/開啓熱敏小票機！',
          type: 'error',
          offset: 160,
        });
        return false;
      } else if (this.feprintlist.length > 1) {
        this.feprintDialogVisible = true;
      } else if (this.feprintlist.length == 1) {
        this.feprint_id = this.feprintlist[0].id;
        this.feprint();
      }

    },
    feprint () {
      let print_id = this.feprint_id;
      if (print_id == '') {
        this.$notify({
          showClose: true,
          message: '請先選擇熱敏小票機！',
          type: 'error',
          offset: 160,
        });
        return false;
      }
      let order_id = this.order_id;
      let store_id = this.store_id;
      this.feprintDialogVisible = false;
      this.post('/api/order/feprint', { order_id, store_id, print_id })
        .then(response => {
          if (response.msg == 'ok') {
            this.$notify({
              showClose: true,
              message: '打印指令已發送！',
              type: 'success',
              offset: 160
            });
          } else {
            this.$notify({
              showClose: true,
              message: response.msg,
              type: 'error',
              offset: 160
            });
          }
        }).catch(error => {
          console.log(error);
        });
    },
    openprint () {
      window.open(this.apiurl + '/api/pcprintshow/' + this.encode_id);
    },
    // 獲取訂單加密後的訂單id	
    getdata () {
      this.post('/api/order/getencode_id', { order_id: this.order_id })
        .then(response => {
          if (response.status == 'success') {
            this.encode_id = response.info.encode_id;
            if (response.info.ordertype == 1) {
              this.printall = true;
            }
          } else {
            this.encode_id = 0;
          }
        }).catch(error => {
          console.log(error);
        });
    }
  },
  created () {
    this.checkorder();
    this.getdata();
  }
};
</script>

<style scoped>
.box-row {
  display: flex;
  align-items: center;
  padding: 10px 0;
}
</style>
